import React from "react";
import FooterFrame from "../assets/ComponentPics/FooterFrame.jpg";
import { FaLinkedin, FaFacebook } from "react-icons/fa";
import { Link } from "react-router-dom";  // Import Link from react-router-dom

const Footer = () => {
  return (
    <>
      <footer className="bg-[#112D4E] text-white py-10 px-4 rounded-xl mt-20 relative">
        {/* Main Content */}
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-sm relative">
          {/* Left Section */}
          <div className="text-center md:text-left">
            <h2 className="text-2xl font-bold mb-2">AIAURA</h2>
            <p className="leading-relaxed">
              Whether you're a growing startup, an enterprise or recruitment company, AIAURA helps individuals and businesses work smarter, not harder. Elevate your recruitment and HR strategies today!
            </p>
          </div>

          {/* Center Section */}
          <div className="hidden md:flex justify-center items-center">
            <span className="border-t border-white/20 w-2/3"></span>
          </div>

          {/* Right Section */}
          <div className="flex justify-center md:justify-end">
            <div className="grid grid-cols-3 gap-8">
              <ul className="space-y-6 text-center md:text-left">
                <li>
                  <Link to="/features" className="hover:text-[#A0CFFF] transition-colors">
                    Features
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-[#A0CFFF] transition-colors">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/resources" className="hover:text-[#A0CFFF] transition-colors">
                    Resources
                  </Link>
                </li>
                <li>
                  <Link to="/fund" className="hover:text-[#A0CFFF] transition-colors">
                    Our Impact Fund
                  </Link>
                </li>
                
              </ul>
              <ul className="space-y-6 text-center md:text-left">
                <li>
                  <Link to="/terms" className="hover:text-[#A0CFFF] transition-colors">
                    Terms & Conditions
                  </Link>
                </li>
                <li>
                  <Link to="/privacypolicy" className="hover:text-[#A0CFFF] transition-colors">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/partner" className="hover:text-[#A0CFFF] transition-colors">
                    Become a Partner
                  </Link>
                </li>
                <li>
                  <Link to="/pricing" className="hover:text-[#A0CFFF] transition-colors">
                    Pricing Plans
                  </Link>
                </li>
              </ul>
              <ul className="space-y-6 text-center md:text-left">
                <li className="hover:text-[#A0CFFF] transition-colors cursor-pointer flex items-center justify-center md:justify-start">
                  <FaLinkedin className="mr-2" />
                  <a
                    href="https://www.linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[#A0CFFF] transition-colors"
                  >
                    LinkedIn
                  </a>
                </li>
                <li className="hover:text-[#A0CFFF] transition-colors cursor-pointer flex items-center justify-center md:justify-start">
                  <FaFacebook className="mr-2" />
                  <a
                    href="https://www.facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-[#A0CFFF] transition-colors"
                  >
                    Facebook
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Links */}
        <div className="border-t border-white/20 mt-10 pt-5 text-center text-xs text-white/80 relative">
          <Link
            to="/privacypolicy"
            className="hover:text-[#A0CFFF] transition-colors"
          >
            Privacy Policy
          </Link>
          <span className="px-2">|</span>
          <Link
            to="/terms"
            className="hover:text-[#A0CFFF] transition-colors"
          >
            Terms & Conditions
          </Link>
          <span className="px-2">|</span>
          <Link
            to="/cookies"
            className="hover:text-[#A0CFFF] transition-colors"
          >
            Cookies Policy
          </Link>
        </div>
        Copyright © 2025 AIAURA Group Ltd. All Rights Reserved
      </footer>

      <div>
        <img
          src={FooterFrame}
          alt="Footer Frame"
          className="w-full h-[150px] object-cover md:object-[center_bottom] mt-[-1px]"
        />
      </div>
    </>
  );
};

export default Footer;
